// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__sNaX8","shadowed2":"BaseLayout_shadowed2__o8Dws","dark":"BaseLayout_dark__km+Xv","light":"BaseLayout_light__ldtJE"};